<template>
  <div
    class="bg-gray-100 md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-no-wrap md:overflow-hidden border-r border-solid border-gray-200 bg-white flex-wrap items-center justify-between relative md:w-64 z-10 py-4 pl-6"
  >
    <div class="mt-10">

<div class="overflow-y-scroll pr-6" style="max-height:500px">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <div
            class="text-xs font-bold uppercase pr-1 py-3 block leading-normal hover:no-underline"
            v-on:click="toggleTabs(1)"
            v-bind:class="{
              ' cursor-pointer border-b-2 border-gray-500 text-blue-500': openTab == 1,
              'text-gray-600 cursor-pointer ':
                openTab === 2,
            }"
          >
            Themes
          </div>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <div
            class="text-xs font-bold uppercase pr-1 py-3 block leading-normal hover:no-underline"
            v-on:click="toggleTabs(2)"
            v-bind:class="{
              ' cursor-pointer border-b-2 border-gray-500 text-blue-500': openTab == 2,
              'text-gray-600 cursor-pointer':
                openTab === 1,
            }"
          >
            Customize
          </div>
        </li>

        <!--
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase px-1 py-3 block leading-normal hover:no-underline"
            v-on:click="toggleTabs(3)"
            v-bind:class="{
              'text-gray-600 hover:text-gray-500 cursor-pointer': openTab !== 3,
              'text-gray-600 hover:text-gray-500 border-b-2 border-gray-500 cursor-pointer':
                openTab === 3,
            }"
          >
            Buttons
          </a>
        </li>
-->
      </ul>

      <div v-if="openTab == 1">
        <div class="">
          <div
            v-for="(scheme, index) in schemes"
            :key="index"
            @click="applyTemplate(scheme)"
            class="py-2 text-center cursor-pointer mb-5 w-7/8 rounded shadow"
            :style="{ 'background-color': scheme.bgColor }"
          >
            <p
              class=""
              :style="{ color: scheme.fontColor, 'font-family': 'Roboto' }"
            >
              {{ scheme.name }}
            </p>
            <div class="flex flex-row justify-center">

              <div
                class="h-6 w-6">

              <span class="material-icons" :style="{
                  'color': scheme.accentColor, 'line-height': '20px','font-size': '25px'}">image</span>
              </div>
              <div
                class="h-5 w-5 "
                :style="{
                  'border-radius': '3px',
                  'background-color': scheme.button_bgColor,
                  border: '1px solid',
                  'border-color': scheme.button_border,
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="openTab == 2">

        <div class="text-xs mx-auto my-3 text-center"> Customize your default theme: </div>

        <div class="text-sm font-semibold flex justify-between py-2">
          Font

          <div class="pt-0">
            <select
              type="text"
              v-model="font"
              placeholder="Placeholder"
              class="px-2 py-1 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
            >
              <option value="lato" style="font-family: 'Lato', san-serif"
                >Lato</option
              >
              <option value="lora" style="font-family: 'Lora', serif"
                >Lora</option
              >
              <option
                value="merriweather"
                style="font-family: 'Merriweather', serif"
                >Merriweather</option
              >
              <option
                value="montserrat"
                style="font-family: 'Montserrat', san-serif"
                >Montserrat</option
              >
              <option
                value="noto_sans"
                style="font-family: 'Noto Sans', san-serif"
                >Noto Sans</option
              >
              <option value="noto_jp" style="font-family: 'Noto JP', san-serif"
                >Noto JP</option
              >
              <option
                value="open_sans"
                style="font-family: 'Open Sans', san-serif"
                >Open Sans</option
              >
              <option value="oswald" style="font-family: 'Oswald', san-serif"
                >Oswald</option
              >
              <option value="poppins" style="font-family: 'Poppins', san-serif"
                >Poppins</option
              >
              <option value="raleway" style="font-family: 'Raleway', san-serif"
                >Raleway</option
              >
              <option value="roboto" style="font-family: 'Roboto', san-serif"
                >Roboto</option
              >
              <option
                value="source_sans"
                style="font-family: 'Source Sans Pro', san-serif"
                >Source Sans Pro</option
              >
            </select>
          </div>
        </div>

        <hr />

        <div class="text-sm font-semibold flex justify-between pt-2 pb-1">
          Text Color
        <color-pop v-model="fontColor" ></color-pop>
        </div>
        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Background Color
          <color-pop
            v-model="bgColor"
            :colorHistory="[
              '#FFFFFF',
              '#F3F3F3',
              '#E8E8E8',
              '#F6F6F6',
              '#FAFBFC',
            ]"
          ></color-pop>
        </div>
        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Image Accent Color
          <color-pop
            v-model="accentColor"
            :colorHistory="swatchColors"
          ></color-pop>
        </div>

        <hr />
        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Button Color
          <color-pop v-model="buttonBgColor"></color-pop>
        </div>
        
        <hr />
        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Button Text Color

          <color-pop v-model="buttonFontColor"></color-pop>
        </div>
        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Button Border Color

          <color-pop v-model="buttonBorderColor"></color-pop>
        </div>

      <hr />

        <div
          class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1"
        >
          Panel Text Color
          <color-pop v-model="fontColor2"></color-pop>
        </div>

        <hr />
        
      <div
          class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1"
        >
          Panel Border Color
          <color-pop v-model="borderColor"></color-pop>
        </div>

        <hr />


      <div
          class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1"
        >
          Panel Selected Color
          <color-pop v-model="selectedColor"></color-pop>
        </div>


      </div>
    </div>  

<div class="pr-6">
<hr class="mt-3 mb-1" /> 
<hr class="mb-5" />
</div>

<div class="pr-6">
      

      <div v-show="hasOptions">
      <div class="text-xs text-gray-500 uppercase font-bold">Survey options</div>
      <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-3">
        <div class="flex-none">Panel Size</div>
        <input
          class="ml-8 w-24"
          type="range"
          min="0"
          max="3"
          v-model="panelSize"
        />
      </div>

      <hr />

      <div
        class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-3"
      >
        <div  v-tooltip="
          'Allow users to select more than one <br/> answer choice for this question.'
        ">Allow multiple answers</div>
        <BaseToggle v-model="allowMany" name="allowMany" :width="8" :height="4" />
      </div>


      </div>

      <div v-show="step.type=='MODAL'">
      <div class="text-xs text-gray-500 uppercase font-bold">Modal options</div>

      <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-3">
        <div class="flex-none">Modal Size</div>
        <input
          class="ml-8 w-24"
          type="range"
          min="1"
          max="3"
          v-model="panelSize"
        />
      </div>
</div>
      <!--
      <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-3">
        Modal Background
        <color-pop v-model="visibleBg"></color-pop>
      </div>
      <div class="flex flex-row mb-1">
        <input
          type="checkbox"
          id="checkbox"
          v-model="checked"
          class="my-auto"
        />
        <label for="checkbox" class="text-xs my-auto">Use theme default</label>
      </div>
      -->

      </div>

    </div>
  </div>
</template>

<script>
//Vue Swatches: https://saintplay.github.io/vue-swatches/
//import VSwatches from "vue-swatches";
// Import the styles too, typically in App.vue or main.js
//import "vue-swatches/dist/vue-swatches.css";

//Verte Color Picker
//https://baianat.github.io/verte/guide/
//import Verte from "verte";
import ColorPop from "@/components/ColorPop";
import Survey from "@/models/Survey";
import Step from "@/models/Step";
import { ColorSchemes } from "@/mixins/ColorSchemes.js";

export default {
  mixins: [ColorSchemes],
  components: { ColorPop },
  data() {
    return {
      openTab: 1,
      checked: true,
    };
  },
  props: ["survey", "step"],
  computed: {
    hasOptions() {
      return this.step.hasOptions;
    },
    swatchColors() {
      return ["#FFFFFF", "#FFDFBC", "#FF6A88", "#D496FB", "#eee666", "#6E8BFF"];
    },
    font: {
      get() {
        return this.survey.font;
      },
      set(value) {
        if (value !== this.survey.font) {
          Survey.update({ where: this.survey.id, data: { font: value } });
        }
      },
    },

    fontColor: {
      get() {
        return this.survey.fontColor;
      },
      set(value) {
        if (value !== this.survey.fontColor) {
          Survey.update({ where: this.survey.id, data: { fontColor: value } });
        }
      },
    },
    bgColor: {
      get() {
        return this.survey.bgColor;
      },
      set(value) {
        if (value !== this.survey.bgColor) {
          Survey.update({ where: this.survey.id, data: { bgColor: value } });
        }
      },
    },

    //custom background color for the step
    stepBg: {
      get() {
        return this.step.bgColor;
      },
      set(value) {
        Step.update({ where: this.step.id, data: { bgColor: value } });
      },
    },

    visibleBg: {
      get() {
        //show custom background color for the step, or else show survey default
        return this.step.bgColor ?? this.survey.bgColor;
      },
      set(value) {
        if (this.checked) {
          value = null;
        }
        Step.update({ where: this.step.id, data: { bgColor: value } });
      },
    },

    allowMany: {
      get() {
        return this.step.allow_many;
      },
      set(value) {
        //console.log("allowmany value: " + value);
        if (value !== this.step.allow_many) {
          Step.update({ where: this.step.id, data: { allow_many: value } });
        }
      },
    },

    buttonFontColor: {
      get() {
        return this.survey.buttonFontColor;
      },
      set(value) {
        if (value !== this.survey.buttonFontColor) {
          Survey.update({
            where: this.survey.id,
            data: { buttonFontColor: value },
          });
        }
      },
    },
    buttonBgColor: {
      get() {
        return this.survey.buttonBgColor;
      },
      set(value) {
        if (value !== this.survey.buttonBgColor) {
          Survey.update({
            where: this.survey.id,
            data: { buttonBgColor: value },
          });
        }
      },
    },
    buttonBorderColor: {
      get() {
        return this.survey.buttonBorderColor;
      },
      set(value) {
        if (value !== this.survey.buttonBorderColor) {
          Survey.update({
            where: this.survey.id,
            data: { buttonBorderColor: value },
          });
        }
      },
    },

    /*
    welcome_button_text: {
      get() {
        return this.button.welcome_text;
      },
      set(value) {
        if (value !== this.button.welcome_text) {
          Button.update({
            where: this.button.id,
            data: { welcome_text: value },
          });
        }
      },
    },
    skip_button_text: {
      get() {
        return this.button.skip_text;
      },
      set(value) {
        if (value !== this.button.skip_text) {
          Button.update({
            where: this.button.id,
            data: { skip_text: value },
          });
        }
      },
    },
    next_button_text: {
      get() {
        return this.button.next_text;
      },
      set(value) {
        if (value !== this.button.next_text) {
          Button.update({
            where: this.button.id,
            data: { next_text: value },
          });
        }
      },
    },
    close_button_text: {
      get() {
        return this.button.close_text;
      },
      set(value) {
        if (value !== this.button.close_text) {
          Button.update({
            where: this.button.id,
            data: { close_text: value },
          });
        }
      },
    },

    */

    panelSize: {
      get() {
        if (this.step.size == "xs") return 0;
        if (this.step.size == "sm") return 1;
        if (this.step.size == "md") return 2;
        if (this.step.size == "lg") return 3;
        else return 0;
      },
      set(value) {
        if (value == 0)
          Step.update({ where: this.step.id, data: { size: "xs" } });
        else if (value == 1)
          Step.update({ where: this.step.id, data: { size: "sm" } });
        else if (value == 2)
          Step.update({ where: this.step.id, data: { size: "md" } });
        else if (value == 3)
          Step.update({ where: this.step.id, data: { size: "lg" } });
      },
    },
    fontColor2: {
      get() {
        return this.survey.fontColor2;
      },
      set(value) {
        if (value !== this.survey.fontColor2) {
          Survey.update({ where: this.survey.id, data: { fontColor2: value } });
        }
      },
    },
    accentColor: {
      get() {
        return this.survey.accentColor;
      },
      set(value) {
        if (value !== this.survey.accentColor) {
          Survey.update({
            where: this.survey.id,
            data: { accentColor: value },
          });
        }
      },
    },
    panelColor: {
      get() {
        return this.survey.panelColor;
      },
      set(value) {
        if (value !== this.survey.panelColor) {
          Survey.update({ where: this.survey.id, data: { panelColor: value } });
        }
      },
    },
    borderColor: {
      get() {
        return this.survey.borderColor;
      },
      set(value) {
        if (value !== this.survey.borderColor) {
          Survey.update({
            where: this.survey.id,
            data: { borderColor: value },
          });
        }
      },
    },
    selectedColor: {
      get() {
        return this.survey.selectedColor;
      },
      set(value) {
        if (value !== this.survey.selectedColor) {
          Survey.update({
            where: this.survey.id,
            data: { selectedColor: value },
          });
        }
      },
    },
  },
  methods: {
    toggleTabs: function(tabNumber) {
      this.openTab = tabNumber;
    },
    //applyTemplate(){} => moved to Template mixin
  },
  watch: {
    checked() {
      if (this.checked == true) this.stepBg = null;
    },
    stepBg() {
      if (this.stepBg == null) this.checked = true;
    },
  },
};
</script>

<style>

</style>
